import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { MapPin } from 'lucide-react';
export function AreasServed() {
  const cities = ['Grapevine', 'Colleyville', 'Southlake', 'Coppell', 'Euless', 'Irving', 'Bedford', 'Hurst', 'Trophy Club', 'Flower Mound', 'Lewisville', 'North Richland Hills', 'Keller', 'Las Colinas', 'Westlake'];
  return <section id="contact" className="py-20 bg-neutral-100 border-t border-neutral-200 bg-cover bg-center relative" style={{
    backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/4u3yK2eDn1ab6gvuBuvKNC/map.png)'
  }} data-id="element-13">
      <div className="absolute inset-0 bg-white/60" data-id="element-14"></div>
      <div className="container mx-auto px-4 text-center max-w-4xl relative z-10" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-16">
          <div className="inline-flex items-center justify-center p-3 bg-red-100 rounded-full mb-6" data-id="element-17">
            <MapPin className="w-6 h-6 text-red-700" data-id="element-18" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-6" data-id="element-19">
            Areas We Serve
          </h2>

          <p className="text-lg text-neutral-600 mb-8 leading-relaxed" data-id="element-20">
            We proudly serve families throughout Grapevine and the surrounding
            communities. Our Taekwondo school is conveniently located at
            Grapevine Mills, making it easy for students from nearby cities to
            train with us consistently.
          </p>

          <div className="flex flex-wrap justify-center gap-2 mb-10" data-id="element-21">
            {cities.map((city, index) => <span key={city} className="px-3 py-1 bg-white border border-neutral-200 rounded-full text-sm font-medium text-neutral-600" data-id="element-22">
                {city}
              </span>)}
          </div>

          <p className="text-lg font-medium text-neutral-800 mb-10" data-id="element-23">
            If you're looking for Taekwondo classes near Grapevine, Texas, our
            programs are designed for students who want high-quality instruction
            within a short drive from home.
          </p>

          <Button href="/signup" data-id="element-24">See If This Is a Fit</Button>
        </motion.div>
      </div>
    </section>;
}